import { Layers, MailWarning, MessageSquareText, Radio, TrendingUp } from "lucide-react";
import { WhatsAppCta } from "../components/WhatsAppCta";
import { useSeo } from "../lib/useSeo";

export function Sms() {
  useSeo({
    title: "SMS em massa",
    description:
      "Campanhas de SMS na SendCube (em breve): alcance qualquer celular, sem depender de internet ou app instalado, complementando o WhatsApp.",
    path: "/sms",
  });

  return (
    <>
      <section className="mx-auto max-w-6xl px-5 pb-14 pt-14 md:pt-20">
        <div className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-white px-3 py-1 text-xs font-bold">
          <MessageSquareText size={14} className="text-brand-600" /> Em breve
        </div>
        <h1 className="mt-5 max-w-[24ch] text-4xl font-extrabold leading-[1.1] md:text-5xl">
          SMS: para onde WhatsApp não alcança
        </h1>
        <p className="mt-5 max-w-[62ch] text-lg text-ink/70">
          Nem todo cliente tem internet ligada o dia inteiro ou usa WhatsApp com frequência. Porém,
          praticamente todo celular recebe SMS. Pensando nisso, a SendCube oferece, também, o
          disparo de SMS em massa. Tudo organizado, assim como as campanhas de WhatsApp.
        </p>
        <div className="mt-8">
          <WhatsAppCta message="Ola! Quero ser avisado quando o SMS em massa da SendCube estiver disponivel.">
            Avise-me quando lançar
          </WhatsAppCta>
        </div>
      </section>

      <section className="border-y-2 border-ink bg-white py-14">
        <div className="mx-auto max-w-6xl px-5">
          <h2 className="text-2xl font-bold">Por que SMS ainda faz diferença</h2>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            <div className="rounded-2xl border-2 border-ink bg-paper p-6 shadow-solid-sm">
              <Radio size={24} className="text-brand-600" />
              <h3 className="mt-3 font-bold">Alcance de qualquer celular</h3>
              <p className="mt-2 text-sm text-ink/60">
                Não depende de internet, de WhatsApp instalado ou de notificação ativada -
                se o numero existe, o SMS chega.
              </p>
            </div>
            <div className="rounded-2xl border-2 border-ink bg-paper p-6 shadow-solid-sm">
              <MailWarning size={24} className="text-brand-600" />
              <h3 className="mt-3 font-bold">Costuma ser lido rapidamente</h3>
              <p className="mt-2 text-sm text-ink/60">
                SMS entra direto na tela de bloqueio do celular, por isso costuma ser aberto e
                lido em poucos minutos, sem competir com outros apps.
              </p>
            </div>
            <div className="rounded-2xl border-2 border-ink bg-paper p-6 shadow-solid-sm">
              <TrendingUp size={24} className="text-brand-600" />
              <h3 className="mt-3 font-bold">Reforça a conversão</h3>
              <p className="mt-2 text-sm text-ink/60">
                Usado junto do WhatsApp, o SMS funciona como um segundo toque: lembra o cliente
                que não respondeu a primeira mensagem, aumentando a chance dele agir.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-14">
        <div className="grid items-center gap-10 md:grid-cols-2">
          <div>
            <Layers size={28} className="text-brand-600" />
            <h2 className="mt-4 text-2xl font-bold">Um canal a mais, não outro sistema</h2>
            <p className="mt-3 text-ink/60">
              O SMS vai funcionar dentro da mesma SendCube que você usa para o WhatsApp: mesma
              planilha, mesmo wizard de criação de campanha, mesmo painel de acompanhamento. O que muda é o canal de saída.
            </p>
          </div>
          <div className="rounded-2xl border-2 border-ink bg-ink p-6 text-white shadow-solid">
            <p className="text-xs font-bold uppercase tracking-wide text-white/50">
              Onde o SMS costuma ganhar do WhatsApp
            </p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>• Cliente sem WhatsApp instalado ou sem internet no momento</li>
              <li>• Avisos urgentes que precisam ser vistos na hora</li>
              <li>• Confirmação de agendamento, entrega ou cobrança</li>
              <li>• Reforçar uma campanha de WhatsApp que não teve resposta</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="border-t-2 border-ink bg-ink py-14 text-center text-white">
        <div className="mx-auto max-w-2xl px-5">
          <h2 className="text-2xl font-bold">O SMS está chegando na SendCube</h2>
          <p className="mt-2 text-white/70">
            Avise-me quando chegar.
          </p>
          <div className="mt-6 flex justify-center">
            <WhatsAppCta message="Ola! Quero ser avisado quando o SMS em massa da SendCube estiver disponivel.">
              Falar no WhatsApp
            </WhatsAppCta>
          </div>
        </div>
      </section>
    </>
  );
}
